import * as React from 'react'
import { Box, Drawer, Typography } from '@mui/material'

import { ReactComponent as CalendarIcon } from 'assets/icons/svg/Calendar.svg'
import { ReactComponent as FilterIcon } from 'assets/icons/svg/AdjustmentHorizontal.svg'

import AttendanceFilterDrawer from './AttendanceFilterDrawer'

import { timeObjectToDateConverter } from 'services/helper/DateTime'
import AdxButton from 'components/custom/AdxButton'

const AttendanceFilter = ({
  drawerState,
  setDrawerState,
  filterValues,
  setFilterValues,
  disableDepartmentSelector,
  disableFilterButton,
}) => {
  return (
    <>
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
        <AdxButton
          variant={'outlined'}
          onClick={() => setDrawerState({ right: true })}
          sx={{ borderColor: 'gray-line.main', width: 'auto' }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'space-between',
              textAlign: 'start',
              gap: 2,
            }}
          >
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Typography sx={{ color: 'light-gray-text.main', fontWeight: 400, lineClamp: 1 }}>
                Time period:
              </Typography>
              <Typography sx={{ color: 'dark-text.main', fontWeight: 500 }}>
                {timeObjectToDateConverter(filterValues.startDate)}
                {filterValues?.endDate && ` - ${timeObjectToDateConverter(filterValues.endDate)}`}
              </Typography>
            </Box>

            <CalendarIcon width={25} color="#2666BE" />
          </Box>
        </AdxButton>
        {/* {!disableFilterButton && (
        <AdxButton
          variant={'outlined'}
          onClick={() => setDrawerState({ right: true })}
          sx={{
            color: 'light-gray-text.main',
            border: '1px solid',
          }}
          width={'10%'}
        >
          <FilterIcon color="dark-text.main" />
        </AdxButton>
      )} */}
      </Box>
      <AttendanceFilterDrawer
        drawerState={drawerState}
        setDrawerState={setDrawerState}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
        disableDepartmentSelector={disableDepartmentSelector}
      />
    </>
  )
}

export default AttendanceFilter
